// LoginPage.jsx
// import ColumnGroup from 'antd/es/table/ColumnGroup';
import React, { useState } from 'react';
import './LoginPage.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { bootstrapPermissions } from '../../util/permission';
const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);

  // 处理输入变化
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    // 清除对应字段的错误
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  // 表单验证
  const validateForm = () => {
    const newErrors = {};

    // 邮箱验证
    if (!formData.email) {
      newErrors.email = '用户名不能为空';
    } else {
      
    }
    //todo
    // 密码验证
    if (!formData.password) {
      newErrors.password = '密码不能为空';
    } else if (formData.password.length < 6) {
      newErrors.password = '密码至少6位字符';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const navigate = useNavigate()
    const toHome = ()=>{
        navigate('/')
    }
  // 处理表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    const data = {
      "clientId": "e5cd7e4891bf95d1d19206ce24a7b32e",
      "grantType": "password",
       "username": formData.email, 
       "password": formData.password

    }
    
    // 模拟API调用
    try {
      await axios.post("/api/auth/login", data)
                .then(async (response) => {
                  console.log(response)
                  if(response.data.code===200){
                    setLoginSuccess(true);
                    localStorage.setItem('token',response.data.data.access_token)
                    try {
                      await bootstrapPermissions();
                    } catch (error) {
                      console.error('获取权限失败', error);
                    }
                    toHome()
                  }else{
                    // setLoginSuccess(false)
                    // alert(response.data.msg)
                    setErrors({ submit: response.data.msg });
                    
                  }
                });
      
     
    } catch (error) {
      setErrors({ submit: '登录失败，请重试' });
    } finally {
      setIsLoading(false);
    }
   
    
      
     
  };

  // 重置表单
  const handleReset = () => {
    setFormData({
      email: '',
      password: '',
      rememberMe: false
    });
    setErrors({});
  };
  const handleClick = async ()=>{
    
    
    
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>欢迎登录</h1>
          <p>请输入您的账号信息</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {errors.submit && (
            <div className="error-message submit-error">
              {errors.submit}
            </div>
          )}

          {loginSuccess && (
            <div className="success-message">
              登录成功！正在跳转...
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">用户名</label>
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={errors.email ? 'error' : ''}
              placeholder="请输入用户名"
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password">密码</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={errors.password ? 'error' : ''}
              placeholder="请输入密码"
            />
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              记住我
            </label>
            <a href="#forgot" className="forgot-link">
              忘记密码？
            </a>
          </div>

          <button
            type="submit"
            className={`login-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
            onClick={handleClick}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                登录中...
              </>
            ) : (
              '登录'
            )}
          </button>

          <button
            type="button"
            className="reset-button"
            onClick={handleReset}
            disabled={isLoading}
          >
            重置
          </button>
        </form>

        <div className="login-footer">
          <p>还没有账号？ <a href="#register">立即注册</a></p>
          
          
        </div>
      </div>
    </div>
  );
};
export default LoginPage;